import React, { useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { useValidate } from "formvalidation/hooks";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  value: string
  onChanged: (newSwiftCode: string) => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  validatorKey: string
}

const SwiftCodeInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const isValidInput = (input: string) => {
    if (input.trim().length === 0) return true;

    if (input.length !== 8 && input.length !== 11) {
      return false;
    }

    return /^[A-Z0-9]+$/.test(input);
  };

  const validate = async (input: string) => {
    const isValid = isValidInput(input);

    return isValid;
  };

  const formatInput = (input: string, e?) => {
    if (isValidInput(input)) {
      e?.preventDefault();
      props.onChanged(input);
      return input;
    }

    const formattedInput = input
      .trim()
      .substring(0, serverReference.constants.bankAccount.maxSwiftCodeLength)
      .toUpperCase();

    if (isValidInput(formattedInput)) {
      e?.preventDefault();
      props.onChanged(formattedInput);
      return formattedInput;
    }

    return false;
  };

  const onPaste = (e) => {
    const text: string = e.clipboardData.getData("text").trim();
    formatInput(text, e);
  };

  const onBlur = () => {
    formatInput(props.value);
  };

  const onChange = (_, { value }) => {
    props.onChanged(value);
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.BankAccount.SwiftCode,
    value: props.value,
    validate: validate,
    ref: semanticRef.ref
  })

  return <Input
    ref={semanticRef.refSetter}
    value={props.value}
    onChange={onChange}
    maxLength={serverReference.constants.bankAccount.maxSwiftCodeLength}
    onPaste={onPaste}
    error={validation.error.hasError}
    onBlur={onBlur}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    fluid
  />;
};

export default SwiftCodeInput;